import { NgSwitch, NgSwitchCase } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, OnDestroy } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { Store } from '@ngrx/store';
import { ProfileDetailsType } from '@shared/models/profile-details-type';
import { IMemberProfile } from '@shared/shared/interfaces/member-profile.interfaces';
import * as MemberProfileStore from '@shared/store/member-profile';
import { Observable, Subject } from 'rxjs';
import { filter, take, takeUntil } from 'rxjs/operators';
import { AddressFormComponent } from './address-form/address-form.component';
import { DeletePopupComponent } from './delete-popup/delete-popup.component';
import { PaymentCardFormComponent } from './payment-card-form/payment-card-form.component';
import { PhoneNumberFormComponent } from './phone-number-form/phone-number-form.component';
import { SpecialOccasionFormComponent } from './special-occasion-form/special-occasion-form.component';
import { TravellerFormComponent } from './traveller-form/traveller-form.component';

export interface PopupFormData {
  formType: ProfileDetailsType;
  dataId?: number;
  maxAllowedDate?: string;
  minAllowedDate?: string;
  data?: any;
}

@Component({
  selector: 'ten-popup-form',
  templateUrl: './popup-form.component.html',
  styleUrls: ['./popup-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    NgSwitch,
    NgSwitchCase,
    TravellerFormComponent,
    PhoneNumberFormComponent,
    SpecialOccasionFormComponent,
    AddressFormComponent,
    PaymentCardFormComponent,
    DeletePopupComponent,
  ],
})
export class PopupFormComponent implements OnDestroy {
  private onDestroy = new Subject<void>();

  public memberProfileUrl: string;
  public ProfileDetailsType = ProfileDetailsType;
  public memberProfile$: Observable<IMemberProfile> = this.ngrxStore.select(
    MemberProfileStore.getMemberProfileFeatureState
  );

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: PopupFormData,
    public dialogRef: MatDialogRef<PopupFormComponent>,
    private ngrxStore: Store<MemberProfileStore.MemberProfileState>
  ) {
    this.memberProfile$
      .pipe(
        takeUntil(this.onDestroy),
        filter((value) => value !== null),
        take(1)
      )
      .subscribe((res) => {
        this.memberProfileUrl = res.url;
      });
  }
  /**
   * Close the current instance of the popup dialog. Called when 'close' emitted value
   * has been detected from child form component.
   */
  public closePopUp() {
    this.dialogRef.close();
  }

  public ngOnDestroy() {
    this.onDestroy.next();
    this.onDestroy.complete();
  }
}
